import { render, staticRenderFns } from "./process2.vue?vue&type=template&id=13f1d46c&scoped=true&"
import script from "./process2.vue?vue&type=script&lang=js&"
export * from "./process2.vue?vue&type=script&lang=js&"
import style0 from "./process2.vue?vue&type=style&index=0&id=13f1d46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1d46c",
  null
  
)

export default component.exports